import React, { useState } from "react";

import AddIcon from "@mui/icons-material/Add";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Button } from "@mui/material";
import { DocumentSectionType } from "constants/documents";
import { DocumentSection } from "store/types";

import { AddSectionContextMenu } from "../Menus/AddSectionContextMenu";
import { useContentContext } from "./content-context";

const insertButtonSx = {
  height: "24px",
  minHeight: "24px",
  color: "#071f35",
  backgroundColor: "#fff",
  border: "1px solid #7b92a9",
  borderRadius: "32px",
  padding: "4px 8px",
  fontSize: "12px",
  fontWeight: 400,
  lineHeight: "16px",
  textTransform: "none",
  minWidth: "auto",
  "&:hover": {
    backgroundColor: "#f5f7fa",
    border: "1px solid #7b92a9"
  },
  "& .MuiButton-startIcon": {
    marginRight: "4px",
    marginLeft: 0
  },
  "& .MuiButton-endIcon": {
    marginLeft: "4px",
    marginRight: 0
  }
} as const;

interface AddSectionToolbarProps {
  sections: DocumentSection[];
  documentDealId: number | null;
}

export const AddSectionToolbar: React.FC<AddSectionToolbarProps> = ({ sections, documentDealId }) => {
  const { createSection, currentSectionId } = useContentContext();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleAddSection = async (type: DocumentSectionType, isAiMeeting?: boolean) => {
    if (!currentSectionId) return;

    // Find the index of the current section
    const currentSectionIndex = sections.findIndex((s) => s.id === currentSectionId);
    if (currentSectionIndex === -1) return;

    // Create new section after the current one
    await createSection({
      position: currentSectionIndex + 1,
      type,
      isAiMeeting
    });
  };

  return (
    <>
      <Button
        sx={insertButtonSx}
        startIcon={<AddIcon sx={{ fontSize: "16px !important" }} />}
        endIcon={<ArrowDropDownIcon sx={{ fontSize: "16px !important" }} />}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        Insert
      </Button>
      <AddSectionContextMenu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        documentDealId={documentDealId}
        onSelect={({ type, isAiMeeting }) => {
          handleAddSection(type, isAiMeeting);
          setAnchorEl(null);
        }}
      />
    </>
  );
};
